import './DownloadButton.css';

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16.8 12.9c0-2.1 1.7-3.1 1.8-3.2-1-1.5-2.5-1.7-3-1.7-1.3-.1-2.5.8-3.1.8-.7 0-1.7-.8-2.8-.7-1.4 0-2.8.8-3.5 2.1-1.5 2.6-.4 6.4 1.1 8.5.7 1 1.6 2.2 2.7 2.1 1.1 0 1.5-.7 2.8-.7s1.7.7 2.8.7c1.2 0 1.9-1 2.6-2.1.8-1.2 1.2-2.4 1.2-2.5 0-.1-2.6-1-2.6-3.3Z" />
      <path d="M14.8 6.6c.6-.8 1-1.8.9-2.9-.9 0-2 .6-2.6 1.3-.6.7-1 1.8-.9 2.8 1 .1 2-.5 2.6-1.2Z" />
    </svg>
  );
}

function DownloadButton() {
  return (
    <a className="button button-primary" href="https://apps.apple.com/us/app/reli-1-minute-reset/id6777772500">
      <span className="button-icon"><AppleIcon /></span>
      <span>Download the app</span>
    </a>
  );
}

export default DownloadButton;
